import { useStore } from 'vuex'

const checkProhibitedRoles = (blackList: any): any => {
  const store = useStore()
  // console.log('store', store)
  // if (blackList.length < 1) {
  //   return true
  // }
  // if (store.state?.userProfile?.RolesName) {
  //   const val = blackList.indexOf(store.state?.userProfile?.RolesName)
  //   return val.length < 0
  // }
  const filteredListSso = blackList.filter((role: any) => store.state?.userProfile?.resource_access['hjp-microservices'].roles.includes(role))
  // console.log('filtered', filteredListSso.length)
  return filteredListSso.length < 1
}

export {
  checkProhibitedRoles
}